// extracted by css-extract-rspack-plugin
export default {"statControl":"CoreStatControl-module__statControl___aoVB7","infoIcon":"CoreStatControl-module__infoIcon___CqTcw"};